import { State } from '.'

export interface UserSettingsState {
  isNavBarCollapse: boolean
}

export const isNavBarCollapse = (state: State) =>
  state.userSettings?.isNavBarCollapse
